/**
 * A fixed path does not allow the widget to move
 */
export class FixedPathObject {
    constructor(origin) {
        Object.defineProperty(this, "origin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.origin = origin;
    }
    onGrab() { }
    onRelease() { }
    mapMotion(position, gesture) { }
    getWidgetPosition() {
        return this.origin;
    }
    getProgress() {
        return 1.0;
    }
    setFromProgress(progress) { }
}
